import { Injectable } from '@angular/core';
import {
  FilterType,
  FrontEndColumn,
} from '@app/shared/interfaces/front-end-column';
import { BehaviorSubject, Subject } from 'rxjs';
import { FilterOperator } from '../models/Enums.enum';
import {
  FilterOperatorModel,
  FilterOperators,
} from '../models/filters.interface';
import { FilterObject, ListPayload } from '../models/ListPayload';

@Injectable({ providedIn: 'root' })
export class FilterLogicService {
  onFilterChange$ = new Subject<{ code: string; filter: FilterObject }>();
  filterChangesObs = this.onFilterChange$.asObservable();
  constructor() {}

  getFilterOperators(column: FrontEndColumn) {
    if (column.filterType == null) return [];
    const operators = FilterOperators;
    switch (column.filterType) {
      case FilterType.String:
      case FilterType.Html:
      case FilterType.Text:
        return operators['String'];

      case FilterType.Number:
        return operators['Number'];

      case FilterType.Date:
        return operators['Date'];

      case FilterType.Select:
      case FilterType.MultiSelect:
        return operators['Select'];

      case FilterType.Boolean:
        return operators['Boolean'];
      default:
        break;
    }
    return [{ code: '', label: '', operator: FilterOperator.inList }];
  }

  handleFilterObject(
    filterObject: FilterOperatorModel,
    value: any,
    column: FrontEndColumn
  ) {
    // if the filter code is number => the column is attribute
    const code = column.filterCode ?? column.name;
    const filterCode = isNaN(+code) ? code : column.name;
    this.onFilterChange$.next({
      code: filterCode,
      filter: {
        AdditionalInfo: filterObject.additionalInfo ?? '{}',
        Operator: filterObject.operator,
        Type: column.filterType!,
        Value: value,
      },
    });
  }

  handleFiltersChanges(
    filter: any,
    payload: ListPayload,
    callGetProducts: () => void) {
    if (filter == null) return;
    // deleting the filter if the value was null or empty
    const additionalInfo = JSON.parse(filter.filter?.AdditionalInfo ?? '{}');
    if ((['', null, undefined, 'null'].includes(filter.filter?.Value?.trim()) &&
        additionalInfo.needValue == null) ||
      (additionalInfo.needValue != null && additionalInfo.needValue === true)
    ) {
      delete payload.Filters[filter.code];
    }
    const keys = Object.keys(payload.Filters);

    if (keys.includes(filter.code)) {
      payload.Filters[filter.code] = filter.filter;
    } else if (
      !['', null, undefined, 'null'].includes(filter.filter?.Value) ||
      additionalInfo.needValue === false
    ) {
      payload.Filters = {
        ...payload.Filters,
        [filter.code]: filter.filter,
      };
    }
    callGetProducts();
    // this.subscriptions.push(this.getProducts().subscribe());
  }
}
